import React from 'react';

interface WelcomeHeroProps {
  userName: string;
}

const WelcomeHero: React.FC<WelcomeHeroProps> = ({ userName }) => {
  return (
    <section className="welcome-hero">
      <div className="hero-background">
        <div className="hero-pattern"></div>
      </div>
      <div className="hero-content">
        <h1 className="hero-title">
          Welcome back, <span className="hero-name">{userName}</span>
        </h1>
        <p className="hero-subtitle">
          Your command center for automation across Easy Street Brands
        </p>
        <div className="hero-stats">
          <div className="hero-stat" title="Placeholder - Coming Soon">
            <span className="stat-icon">⚡</span>
            <div>
              <span className="stat-number">--</span>
              <span className="stat-text">Automations Running</span>
              <span className="stat-note">(Coming Soon)</span>
            </div>
          </div>
          <div className="hero-stat" title="Placeholder - Coming Soon">
            <span className="stat-icon">⏱️</span>
            <div>
              <span className="stat-number">--</span>
              <span className="stat-text">Time Saved This Week</span>
              <span className="stat-note">(Coming Soon)</span>
            </div>
          </div>
          <div className="hero-stat" title="Placeholder - Coming Soon">
            <span className="stat-icon">📈</span>
            <div>
              <span className="stat-number">--</span>
              <span className="stat-text">Efficiency Increase</span>
              <span className="stat-note">(Coming Soon)</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeHero;